<template>
  <div
    class="project-select"
    :class="{ 'is-invalid': invalid }"
  >
    <select
      ref="select"
      class="form-select form-select-sm"
      :disabled="disabled"
    />
  </div>
</template>

<script>
/**
 * Select2 (global jQuery plugin, loaded by the backend layout) with an AJAX project search.
 * `v-model` is the project id; `select` hands the parent the picked { id, text }.
 * A saved row without a project id (filed before projects were linked) shows its name as
 * the selected text until another project is picked.
 */
export default {
    name: "ProjectSelect",
    props: {
        value: {
            type: [Number, String],
            default: null,
        },
        text: {
            type: String,
            default: "",
        },
        url: {
            type: String,
            required: true,
        },
        managerStaffId: {
            type: [Number, String],
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        invalid: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: "Search project",
        },
    },
    watch: {
        disabled(value) {
            window.$(this.$refs.select).prop("disabled", value);
        },
    },
    mounted() {
        const $select = window.$(this.$refs.select);

        if (this.text) {
            $select.append(new Option(this.text, this.value || this.text, true, true));
        }

        $select.select2({
            theme: "bootstrap-5",
            width: "100%",
            placeholder: this.placeholder,
            allowClear: true,
            ajax: {
                url: this.url,
                dataType: "json",
                delay: 250,
                data: (params) => ({
                    search: params.term,
                    page: params.page || 1,
                    manager_staff_id: this.managerStaffId,
                }),
                processResults: (data) => ({
                    results: data.data,
                    pagination: {
                        more: data.current_page * data.per_page < data.total,
                    },
                }),
            },
        });

        $select.on("select2:select", (e) => {
            const { id, text } = e.params.data;
            this.$emit("input", Number(id));
            this.$emit("select", { id: Number(id), text });
        });
        $select.on("select2:clear", () => {
            this.$emit("input", null);
            this.$emit("select", { id: null, text: "" });
        });
    },
    beforeDestroy() {
        const $select = window.$(this.$refs.select);
        $select.off("select2:select select2:clear");
        if ($select.data("select2")) {
            $select.select2("destroy");
        }
    },
};
</script>

<style scoped>
.project-select.is-invalid ::v-deep .select2-selection {
    border-color: var(--bs-form-invalid-border-color, #dc3545);
}
</style>
